const angular = require('angular');
const app = angular.module('learn-directives');
var dragula = require('../../../../node_modules/dragula/dragula');
/**
 * Defines the Assessment Question Manager Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('questionManager', ['AssessmentLib', '$translate', function (AssessmentLib, $translate) {
  return {
    restrict: 'E',
    scope: {
      assessment: '=',
      activeChange: '=',
      checkManual: '&',
      save: '&'
    },
    template: require('../../../templates/directives/assessments/question-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      // Temporary until css implementation of :hover
      $scope.tempHover = {};
      self.info = {
        formatDirectory: {
          multiple_choice: '',
          checkbox: '',
          dropdown: '',
          short_input: '',
          long_input: ''
        },
        sortByProp: function(arr, prop) {
          arr.sort(function(a, b) {
            if (a[prop] > b[prop]) {
              return 1;
            }
            if (a[prop] < b[prop]) {
              return -1;
            }
            return 0;
          });
        }
      };

      self.pages = {
        currentPage: 0,
        addPage: function() {
          self.pages.currentPage++;
          $scope.assessment.pages = self.pages.currentPage + 1;
          self.questions.organizedList[self.pages.currentPage] = [];
          self.questions.parse();
        },
        removePage: function(index) {
          var startingIndex = 0;
          $scope.assessment.questions.forEach(function(question) {
            if (question.page === (index - 1)) {
              startingIndex++;
            }
          });
          $scope.assessment.questions.forEach(function(question) {
            if (question.page === index) {
              question.position = question.position + startingIndex;
            }
            if (question.page >= index && question.page > 0) {
              question.page--;
            }
          });
          if (self.pages.currentPage > 0) {
            self.pages.currentPage--;
          }
          self.questions.parse();
          $scope.assessment.pages -= 1;        
        }
      };

      self.questions = {
        parse: function() {
          self.questions.organizedList = {};

          if (!$scope.assessment || !$scope.assessment.questions || !$scope.assessment.questions.length) {
            return;
          }
          var toOrder = {};
          var max = 0;
          $scope.assessment.questions.forEach(function(item) {
            if (!item.page && item.page !== 0) {
              return;
            }
            toOrder[item.page] = true;
            max = item.page > max ? item.page : max;
            if (!self.questions.organizedList[item.page]) {
              self.questions.organizedList[item.page] = [];
            }
            self.questions.organizedList[item.page].push(item);
          });

          for (var key in toOrder) {
            self.info.sortByProp(self.questions.organizedList[key], 'position');
          }

          max = self.pages.currentPage > max ? self.pages.currentPage : max;
          self.pages.currentPage = max;
          while (max >= 0) {
            if (!self.questions.organizedList[max]) {
              self.questions.organizedList[max] = [];
            }
            max--;
          }

          setTimeout(function() {
            $scope.$apply();
            self.dragConfig.setDrag();
          }, 5);
        },
        organizedList: {},
        dragManagement: null,
        nextPositionOnPage: function() {
          var tally = 0;
          $scope.assessment.questions.forEach(function(question) {
            if (question && question.page === self.pages.currentPage) {
              tally++;
            }
          });
          return tally;
        },
        addEditQuestion: function(edit, format) {
          if (!edit) {
            var item = {
              id: AssessmentLib.helpers.makeId(),
              page: self.pages.currentPage,
              position: self.questions.nextPositionOnPage(),
              format: format || null,
              question: '',
              choice_options: [],
              question_options: [],
              newQuestion: true
            };
            self.questions.setActive(item);
            return;
          }

          if (!edit.id || !$scope.assessment || !$scope.assessment.questions || !$scope.assessment.questions.length) {
            return;
          }

          for (var i = 0; i < $scope.assessment.questions.length; i++) {
            if ($scope.assessment.questions[i].id === edit.id) {
              self.questions.setActive($scope.assessment.questions[i]);
              return;
            }
          }
        },
        saveNewQuestion: function(question) {
          function parseAndClose() {
            self.questions.showAddNew = false;
            self.questions.parse();
            $scope.activeChange = false;
            if ($scope.assessment._id) {
              $scope.save();
            }
          };

          if (!$scope.assessment || !$scope.assessment.questions) {
            // throw error but don't add incase of accidental overwrite
            return;
          }

          if (question.id && $scope.assessment.questions.length) {
            for (var i = 0; i < $scope.assessment.questions.length; i++) {
              if ($scope.assessment.questions[i].id === question.id) {
                $scope.assessment.questions[i] = question;
                parseAndClose();
                return;
              }
            }
          }

          $scope.assessment.questions.push(question);
          if ($scope.checkManual) {
            $scope.checkManual();
          }
          parseAndClose();
        },
        removeQuestion: function(question) {
          if (!question || !question.id || !$scope.assessment || !$scope.assessment.questions || !$scope.assessment.questions.length) {
            return;
          }
          for (var i = 0; i < $scope.assessment.questions.length; i++) {
            if ($scope.assessment.questions[i] && $scope.assessment.questions[i].id === question.id) {
              $scope.assessment.questions.splice(i, 1);
              if ($scope.checkManual) {
                $scope.checkManual();
              }
              self.questions.parse();
              // *** Save or otherwise show save option ***
            }
          }
        },
        setActive: function(item) {
          self.questions.activeQuestion = item;
          self.questions.showAddNew = true;
          $scope.activeChange = true;
        },
        activeQuestion: null,
        showAddNew: false,
        closeBuilder: function() {
          if (!$scope.assessment.questions || !$scope.assessment.questions.length) {
            return;
          }
          self.questions.showAddNew = false;
          $scope.activeChange = false;
        },
        getPoints: function(question) {
          return AssessmentLib.helpers.getQuestionValue(question);
        },
        reorder: function() {
          var selected = document.querySelectorAll('#choice-q-manager');
          var questions = {};

          function addQuestion(q, page, position) {
            if (!q.id) {
              return;
            }
            questions[q.id] = {page: parseInt(page), position: parseInt(position)};
          };

          for (var i = 0; i < selected.length; i++) {
            if (!selected[i].children) {
              continue;
            }
            for (var j = 0; j < selected[i].children.length; j++) {
              addQuestion(selected[i].children[j], selected[i].dataset.page, j);
            }
          }

          $scope.assessment.questions.forEach(function(item) {
            if (item.id && questions[item.id]) {
              item.page = questions[item.id].page;
              item.position = questions[item.id].position;
            }
          });

          self.questions.organizedList = {};
          for (var i = 0; i < selected.length; i++) {
            var node = selected[i];
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
          }
          setTimeout(function() {
            $scope.$apply();
            self.questions.parse();
          }, 5);
        }
      };

      self.dragConfig = {
        create: function() {
          if (self.questions.dragManagement && self.questions.dragManagement.destroy) {
            self.questions.dragManagement.destroy();
          }
          self.questions.dragManagement = null;
          self.questions.dragManagement = dragula({
            direction: 'vertical',
            copy: false,
            mirrorContainer: document.querySelectorAll('#mirror-q-manager')[0]
          });
        },
        setDrag: function() {
          self.dragConfig.create();
          setTimeout(function() {
            self.questions.dragManagement.containers = [];
            var selected = document.querySelectorAll('#choice-q-manager');
            for (var i = 0; i < selected.length; i++) {
              self.questions.dragManagement.containers.push(selected[i]);
            }
            self.questions.dragManagement.on('drop', function(el, target, source, sibling) {
              setTimeout(function() {
                self.questions.reorder();
              }, 10);
            });
            $scope.$apply();
          }, 10);
        }
      }
      self.dragConfig.setDrag();

      self.initialize = function() {
        if (!$scope.assessment.questions || !$scope.assessment.questions.length) {
          self.questions.addEditQuestion();
          return;
        }
        self.questions.parse();
      };

      if (!$scope.assessment) {
        var assessmentWatch = $scope.$watch('assessment', function(newVal, oldVal) {
          if (newVal) {
            self.initialize();
            assessmentWatch();
          }
        });
        return;
      }

      $translate([
        'edit.assessment.multiple_choice',
        'edit.assessment.checkboxs',
        'edit.assessment.dropdown',
        'edit.assessment.single_input',
        'edit.assessment.long_input'
      ]).then(function(translations) {
        self.translations = translations;
        self.info.formatDirectory = {
          multiple_choice: translations['edit.assessment.multiple_choice'],
          checkbox: translations['edit.assessment.checkboxs'],
          dropdown: translations['edit.assessment.dropdown'],
          short_input: translations['edit.assessment.single_input'],
          long_input: translations['edit.assessment.long_input']
        };
        
        self.initialize();
      });

    }],
    controllerAs: 'questionManager'
  };
}]);